<template>

      <div class="contact-info">
        <form @submit.prevent="submitForm" class="contact-page-form">

            <h2 class="con-get">Get in Touch</h2>

            <InputField class="col-md-12" type="text" :is-required="true" :label="$t('Your Name')" placeholder="Name" v-model="name" :error-message="errors['name']" :error-messages="errorMessages['name']"></InputField>


            <InputField class="col-md-12" type="text" :is-required="true" :label="$t('Email Address')" placeholder="Email Address" v-model="email" :error-message="errors['email']" :error-messages="errorMessages['email']"></InputField>


            <InputField class="col-md-12" type="text" :is-required="true" :label="$t('Phone Number')" placeholder="Phone Number" v-model="phone" :error-message="errors['phone']" :error-messages="errorMessages['phone']"></InputField>

            <label for="">Message</label>
            <textarea v-model="message" id="message" name="message" cols="30" rows="10" class="form-control textarea" placeholder="Message"></textarea>


          <div class="submit-btn pt-3">
            <button type="submit">
              SUBMIT
              <!-- <span>
                <img :src= "imgUrl" alt="image" width="20">
              </span> -->
            </button>
          </div>
        </form>
      </div>

</template>

<script setup>
    import {ref} from 'vue';
    import InputField from '@/vue/components/form-elements/InputField.vue'
    import { useField, useForm } from 'vee-validate'
    import * as yup from 'yup'
    import axios from 'axios'

    const errorMessages = ref({});
    const { baseUrl } = defineProps(['baseUrl']);
    // const imgUrl =  '/rc-pet/public/images/icon14.png';
    const imgUrl =  '/images/icon14.png';
    const defaultData = () => {
        errorMessages.value = {}
        return {
            phone: '',
            name: '',
            email: '',
        }
    }
    const setFormData = (data) => {
        resetForm({
            values: {
                phone: data.phone,
                name: data.name,
                email: data.email,
            }
        })
    }
    const validationSchema = yup.object({
        phone: yup.string().required('Phone is a required field').matches(/^\d{10}$/, 'Phone must be exactly 10 digits'),
        name: yup.string().required('Name is a required field'),
        email: yup.string().required('Email is a required field').matches(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/,'Invalid email address'),
    })

    const { handleSubmit, errors, resetForm } = useForm({
        validationSchema
    })
   
    const { value: phone } = useField('phone')
    const { value: name } = useField('name')
    const { value: email } = useField('email')
    const { value: message } = useField('message')
  

    const submitForm = handleSubmit(async () => {
        console.log('Submitting form...');
        console.log('Request payload:', {
            name: name.value,
            email: email.value,
            phone: phone.value,
            message: message.value,
        });
        try{
            const response = await axios.post(`contact-us` ,{
                name: name.value,
                email: email.value,
                phone: phone.value,
                message: message.value,
            });
            console.log('Form submitted successfully:', response);
            resetForm();
            if(response){
                window.successSnackbar("Admin will reach you shortly")
            }
        }catch (error) {
            console.error('Error occurred during form submission:', error);
            if (error.response && error.response.data && error.response.data.errors) {
                errorMessages.value = error.response.data.errors;
            } else {
                console.error('Error:', error);
            }
        }
    });
    
</script>

